import { useState } from 'react';

/**
 * Manages UI overlay and form-level display state.
 *
 * Owns:
 * - renderForm / enableElems: toggles that trigger re-renders after page transitions
 * - renderingEl: the currently visible page container from elementContainer
 * - isFormSubmission: disables buttons while an API call is in flight
 * - isSubmitButtonDisable: controls the primary submit button's disabled state
 * - disabledButtons: map of button IDs disabled by dynamic display rules
 * - apiResponse: latest response from on-change API calls
 */
const useOverlayState = () => {
  const [renderForm, setRenderForm] = useState(true);
  const [enableElems, setEnableElems] = useState(false);
  const [renderingEl, setRenderingEl] = useState([]);
  const [isFormSubmission, setIsFormSubmission] = useState(false);
  const [isSubmitButtonDisable, setIsSubmitButtonDisable] = useState(true);
  const [disabledButtons, setDisabledButtons] = useState({});
  const [apiResponse, setApiResponse] = useState({});

  return {
    renderForm,
    setRenderForm,
    enableElems,
    setEnableElems,
    renderingEl,
    setRenderingEl,
    isFormSubmission,
    setIsFormSubmission,
    isSubmitButtonDisable,
    setIsSubmitButtonDisable,
    disabledButtons,
    setDisabledButtons,
    apiResponse,
    setApiResponse,
  };
};

export default useOverlayState;
